import { z } from 'my-zod'
import { customerWaiverModel } from './customer-waivers-model'

const additionalRider = z.object({
  id: z.string().uuid(),
  type: z.enum(['Adult', 'MinorFamilyMember', 'UnaccompaniedMinor']),
  email: z.string().nullable(),
  firstName: z.string().max(50),
  lastName: z.string().max(50)
})

export const customerWaiverSubmit = customerWaiverModel
  .pick({
    id: true,
    operatorId: true,
    language: true,
    proposedRideDate: true,

    firstName: true,
    lastName: true,
    email: true,
    primaryPhone: true,
    birthDate: true,

    addressLine1: true,
    addressLine2: true,
    city: true,
    state: true,
    postalCode: true,
    country: true,

    driverLicenseState: true,
    driverLicenseNumber: true,

    firstTimeRider: true,
    hasMotorcycleLicense: true,
    additionalEmailOptIn: true,

    outfitterWaiverContentId: true,
    outfitterWaiverContentVersionId: true,

    additionalWaiverQuestionResponses: true
  })
  .augment({
    signature: z
      .string()
      .min(1)
      .refine((content) => content.startsWith('data:')),
    driverLicenseFrontPic: z
      .string()
      .min(1)
      .refine((content) => content.startsWith('data:')),
    riderId: z.string().min(1),
    additionalRiders: additionalRider.array()
  })
